// Libs
import classNames from 'classnames/bind';
import { Box, Stack } from '@mui/material';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './TypingDots.module.scss';

type Props = { height?: number };

const cx = classNames.bind(styles);

const TypingDots = (props: Props) => {
  //#region Destructuring Props
  const { height } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack component={'div'} direction={'row'} alignItems={'center'} spacing={'3px'} style={{ height }}>
      {Array(3)
        .fill(null)
        .map((_, index) => (
          <Box component={'div'} className={cx('dot')} key={index} />
        ))}
    </Stack>
  );
};

export default TypingDots;
